export default __webpack_public_path__ + "static/retail-insta-124c39a66eae764922088b7266e27d49.png";